import { NavigationBar } from '../Landing/NavigationBar';
import Footer from '../Footer';
import Ticket from '../../assets/images/ticket.png';
import location from '../../assets/images/Icons/location.svg';
import CustomMap from './CustomMap';
import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ApiClient from '../../methods/api/apiClient';
import moment from 'moment';
import methodModel from '../../methods/methods';
import { useSelector } from 'react-redux';
import { CiLocationOn, CiSearch } from 'react-icons/ci';
import loader from '../../methods/loader';
import { FaFilter } from "react-icons/fa6";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import SocialShare from '../../common/SocialShare';
import SelectDropdown from '../../common/SelectDropdown';
import milesModal from '../../models/miles.modal';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import environment from '../../environment';
import { IoMdClose } from "react-icons/io";
import { FaBarsStaggered } from "react-icons/fa6";
import { IoMdRefresh } from "react-icons/io";

const FilterPage = () => {
    const { filter } = useParams()
    const userLat = sessionStorage.getItem("userLat")
    const userLong = sessionStorage.getItem("userLong")
    const currentDomain = window.location.host
    const [data, setData] = useState([])
    const search = useSelector((state) => state.search.data)
    const [filters, setFilters] = useState({ search: "", location: "", date: "", range: "32186.9", lat: userLat, long: userLong, startDate: "", endDate: "", category: [], subCategory: [], subAmenities: [], type: "", status: "active" })
    const [locations, setLocations] = useState([{ lat: "", lng: "", icon: "", info: "" }])
    const [mapView, setMapView] = useState([])
    const [categories, setCategories] = useState([])
    const [subCategories, setSubCategories] = useState([])
    const [amenities, setAmenities] = useState([])
    const [filterOptions, setFilterOptions] = useState({ category: false, subCategory: false, subAmenities: false })
    const [isChecked, setIsChecked] = useState(false);
    const [customDate, setCustomDate] = useState(false)
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [isOpen, setIsOpen] = useState(false);

    const toggleModal = () => {
      setIsOpen(!isOpen);
    };

    useEffect(() => {
        getAllCategoriesSubCategories()
        // getAllSubCategories()
        getAllAmenities()
    }, [])

    useEffect(() => {
        setFilters({ ...filters, search: search?.name || "", location: search?.location || "" })
        getData({ search: search?.name || "", location: search?.location || "" })
    }, [search])

    const getData = (f = {}) => {
        let params = { ...filters, category: filters?.category ? String(filters?.category) : "", ...f, value: "upcoming" }
        if (filter) {
            params = { ...params, [filter]: true }
        }
        loader(true)
        ApiClient.get(`event/listing`, params).then(res => {
            if (res.success) {
                setData(res?.data)
                let locations = []
                let mapview = {}
                res?.data?.map((item, index) => {
                    locations.push({ lat: item?.coordinates?.coordinates?.[1], lng: item?.coordinates?.coordinates?.[0], icon: methodModel.noImg(item?.images?.[0]), info: item?.title })
                    if (index === 0) {
                        mapview = { lat: item?.coordinates?.coordinates?.[1], lng: item?.coordinates?.coordinates?.[0], icon: methodModel.noImg(item?.images?.[0]), info: item?.title }
                    }
                })
                setLocations(locations)
                setMapView(mapview)
            }
            loader(false)
        })
    }
    const getAllCategoriesSubCategories = () => {
        ApiClient.get(`category/group?status=active&sortBy=name asc`).then(res => {
            if (res.success) {
                setCategories(res?.data)
            }
        })
    }
    // const getAllSubCategories = () => {
    //     ApiClient.get(`sub/listing?status=active&sortBy=name asc&categoryId=`).then(res => {
    //         if (res.success) {
    //             setSubCategories(res?.data)
    //         }
    //     })
    // }
    const getAllAmenities = () => {
        ApiClient.get(`amenity/listing?status=active&sortBy=title asc`).then(res => {
            if (res.success) {
                setAmenities(res?.data)
            }
        })
    }

    const handleSearch = (e) => {
        e.preventDefault()
        getData({ search: filters?.search })
    }
    const clearFilter = () => {
        setFilters({ ...filters, search: "", location: "", date: "", range: "32186.9", lat: userLat, long: userLong, status: "active" })
        getData({ search: "", location: "", date: "", range: "32186.9", lat: userLat, long: userLong, status: "active" })
    }
    const clearSidebarFilters = () => {
        setFilters({ ...filters, category: [], subCategory: [], subAmenities: [], date: "", type: "", startDate: "", endDate: "" })
        getData({ category: [], subCategory: [], subAmenities: [], date: "", type: "", startDate: "", endDate: "" })
        setCustomDate(false)
        setDateRange([null, null])
    }
    const handleFilters = (value, key) => {
        if (key === "category" || key === "subCategory" || key === "subAmenities") {
            let data = filters?.[key]
            if (data.includes(value)) {
                data = data.filter(item => item !== value)
            } else {
                data.push(value)
            }
            setFilters({ ...filters, [key]: data })
            getData({ [key]: String(data) })
        } else if (key === "date") {
            let date = "";
            setCustomDate(false)
            setDateRange([null, null])
            if (value === "today") {
                date = moment();
            } else if (value === "tomorrow") {
                date = moment().add(1, 'days');
            }
            const formattedDate = date.format("MM/DD/YYYY");
            setFilters({ ...filters, [key]: value, startDate: "", endDate: "" })
            getData({ [key]: formattedDate, startDate: "", endDate: "" });
        }
        else {
            setFilters({ ...filters, [key]: value })
            getData({ [key]: value })
        }
    }
    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    }
    const handleDateRangeFilter = (date) => {
        setDateRange(date)
        if (date?.[0] && date?.[1] || !date?.[0] && !date?.[1]) {
            const start = date?.[0] ? moment(date?.[0]).format("YYYY-MM-DD") : ""
            const end = date?.[1] ? moment(date?.[1]).format("YYYY-MM-DD") : ""
            setFilters((prev) => ({ ...prev, startDate: start, endDate: end, date: "" }))
            getData({ startDate: start, endDate: end, date: "" });
        }
    }

    const handleLocation = (place) => {
        setFilters({ ...filters, location: place?.formatted_address, lat: place.geometry.location.lat(), long: place.geometry.location.lng() })
    }

    return (
        <>
            <NavigationBar />
            <div className="bg-[#D9D9D938]">
                <div className="flex relative">
                    <div>
    <div className={`w-full lg:min-w-[280px] lg:w-[280px] fixed lg:relative top-0 left-0 h-full z-50 bg-white shadow-lg lg:border-none border-r border-[#6F6F6F4D] transform max-lg:bg-[#0006] ${isOpen ? 'translate-x-0' : 'max-lg:translate-x-[-100%]'} `}>
    <div className={`px-2 w-full flex flex-col gap-3 pt-3 pb-4 border-r border-[#6F6F6F4D] max-w-[280px] bg-white transform ${isOpen ? 'translate-x-0' : 'max-lg:translate-x-[-100%]'} transition-transform duration-300 ease-in-out`}>
                            <div className=''>
                                    <div className="flex gap-5 justify-between items-center font-semibold text-xl leading-[30px] text-left text-[#134896] font-montserrat border-b p-3 mb-3"><span>Filters</span>
                                    <div className='flex gap-3'>
                                    {filters?.category?.length > 0 || filters?.subCategory?.length > 0 || filters?.subAmenities?.length > 0 || filters?.date || filters?.type || customDate ?
                                            <IoMdRefresh onClick={e => clearSidebarFilters()} className="lg:hidden text-2xl" />
                                           : null}
                                    <IoMdClose onClick={toggleModal} className="lg:hidden text-[#707070] text-2xl" />       
                                    {filters?.category?.length > 0 || filters?.subCategory?.length > 0 || filters?.subAmenities?.length > 0 || filters?.date || filters?.type || customDate ?
                                            <button onClick={e => clearSidebarFilters()} className='border rounded-md text-center h-7 flex justify-center items-center px-2 py-1 w-full font-[500] text-[12px] text-center text-[#005AAB] max-lg:hidden'>Clear Filters</button>
                                            : null}
                                    </div>
                                    </div>
                                    <div className='mb-3'>
                                       
                                    </div>
                                <div className='h-[calc(100vh_-_95px)] lg:h-[calc(100vh_-_183px)] overflow-auto scrollhide'>
                                <div className="flex flex-col gap-3 pb-[20px] border-b border-[#6F6F6F4D]">
                                    <h3 className="font-semibold text-md leading-[28px] text-left text-[#2D2C3C] font-open-sans">
                                        Category & Sub Category
                                    </h3>
                                    <div className='max-h-[210px] overflow-auto grid grid-cols-1 gap-1'>
                                        {categories?.slice(0, filterOptions?.category ? 10000 : 6)?.map((item, index) => {
                                            return <div className="grid grid-cols-1 gap-3 mb-3 pl-3" key={index}>
                                                <div className='flex gap-1 items-center'>
                                                    <input type="checkbox" className='cursor-pointer focus:ring-0 focus:shadow-none' id={`checkbox${index}`} onChange={e => handleFilters(item?._id || item?.id, "category")} checked={filters?.category?.includes(item?._id || item?.id)} />
                                                    <label htmlFor={`checkbox${index}`} className='capitalize text-[13px] cursor-pointer'>{item?.categoryName}</label>
                                                </div>
                                                {item?.subcategories?.map((itm, i) => {
                                                    return <div className='flex gap-2 ml-2' key={i}>
                                                        <input type="checkbox" className='cursor-pointer focus:ring-0 focus:shadow-none' id={`subCheckbox${index}${i}`} onChange={e => handleFilters(itm?._id || itm?.id, "subCategory")} checked={filters?.subCategory?.includes(itm?._id || itm?.id)} />
                                                        <label htmlFor={`subCheckbox${index}${i}`} className="font-normal text-xs leading-[24px] text-left text-[#2B293D] font-open-sans capitalize cursor-pointer">{itm?.name}</label>
                                                    </div>
                                                })}
                                            </div>
                                        })}
                                        {/* {categories?.slice(0, filterOptions?.category ? 10000 : 6)?.map((itm, i) => {
                                            return <div className="flex items-center gap-[10px]" key={i}>
                                                <input type="checkbox" className='cursor-pointer focus:ring-0 focus:shadow-none' id={`checkbox${i}`} onChange={e => handleFilters(itm?._id || itm?.id, "category")} checked={filters?.category?.includes(itm?._id || itm?.id)} />
                                                <label htmlFor={`checkbox${i}`} className="font-normal text-xs leading-[24px] text-left text-[#2B293D] font-open-sans capitalize cursor-pointer">{itm?.name}</label>
                                            </div>
                                        })} */}
                                    </div>
                                    <div className="flex items-center gap-[10px] ml-auto">
                                        <div onClick={e => setFilterOptions({ ...filterOptions, category: !filterOptions?.category })} className="font-normal text-xs leading-[24px] text-left text-[#005AAB] cursor-pointer font-open-sans">{filterOptions?.category ? "Less" : "More"}</div>
                                    </div>
                                </div>
                                {/* <div className="flex flex-col gap-3 pb-[20px] border-b border-[#6F6F6F4D]">
                                    <h3 className="font-semibold text-md leading-[28px] text-left text-[#2D2C3C] font-open-sans">
                                        Sub Category
                                    </h3>
                                    <div className='max-h-[164px] overflow-auto grid grid-cols-1 gap-1 mb-3'>
                                        {subCategories?.slice(0, filterOptions?.subCategory ? 10000 : 6)?.map((itm, i) => {
                                            return <div className="flex items-center gap-[10px]" key={i}>
                                                <input type="checkbox" className='cursor-pointer focus:ring-0 focus:shadow-none' id={`subCheckbox${i}`} onChange={e => handleFilters(itm?._id || itm?.id, "subCategory")} checked={filters?.subCategory?.includes(itm?._id || itm?.id)} />
                                                <label htmlFor={`subCheckbox${i}`} className="font-normal text-xs leading-[24px] text-left text-[#2B293D] font-open-sans capitalize cursor-pointer">{itm?.name}</label>
                                            </div>
                                        })}
                                    </div>
                                    <div className="flex items-center gap-[10px] ml-auto">
                                        <div onClick={e => setFilterOptions({ ...filterOptions, subCategory: !filterOptions?.subCategory })} className="font-normal text-xs leading-[24px] text-left text-[#005AAB] cursor-pointer font-open-sans">{filterOptions?.subCategory ? "Less" : "More"}</div>
                                    </div>
                                </div> */}
                                <div className="flex flex-col gap-3 pb-[20px] border-b border-[#6F6F6F4D]">
                                    <h3 className="font-semibold text-md leading-[28px] text-left text-[#2D2C3C] font-open-sans">Amenities</h3>
                                    <div className='max-h-[230px] overflow-auto'>
                                        {amenities?.slice(0, filterOptions?.subAmenities ? 10000 : 6)?.map((item, index) => {
                                            return <div className="grid grid-cols-1 gap-3 mb-3 pl-3" key={index}>
                                                <h3 className='capitalize text-[13px]'>{item?.title}</h3>
                                                {item?.subAmenities?.map((itm, i) => {
                                                    return <div className='flex gap-2' key={i}>
                                                        <input type="checkbox" className='cursor-pointer focus:ring-0 focus:shadow-none' id={`subAmenitiesCheckbox${index}${i}`} onChange={e => handleFilters(itm?._id || itm?.id, "subAmenities")} checked={filters?.subAmenities?.includes(itm?._id || itm?.id)} />
                                                        <label htmlFor={`subAmenitiesCheckbox${index}${i}`} className="font-normal text-xs leading-[15px] text-left text-[#2B293D] font-open-sans capitalize cursor-pointer">{itm?.title}</label>
                                                    </div>
                                                })}
                                            </div>
                                        })}
                                    </div>
                                    <div className="flex items-center gap-[10px] ml-auto">
                                        <div onClick={e => setFilterOptions({ ...filterOptions, subAmenities: !filterOptions?.subAmenities })} className="font-normal text-xs leading-[24px] text-left text-[#005AAB] cursor-pointer font-open-sans">{filterOptions?.subAmenities ? "Less" : "More"}</div>
                                    </div>
                                </div>
                                <div className="flex flex-col gap-3 pb-[20px] border-b border-[#6F6F6F4D]">
                                    <h3 className="font-semibold text-md leading-[28px] text-left text-[#2D2C3C] font-open-sans">Date</h3>
                                    <div>
                                        <div className="flex items-center gap-[10px]">
                                            <input type="radio" checked={filters?.date === "today"} onClick={e => handleFilters("today", "date")} id="today" name="date" className='cursor-pointer' />
                                            <label htmlFor="today" className="font-normal cursor-pointer text-xs leading-[24px] text-left text-[#2B293D] font-open-sans">
                                                Today
                                            </label>
                                        </div>
                                        <div className="flex items-center gap-[10px]">
                                            <input type="radio" checked={filters?.date === "tomorrow"} onClick={e => handleFilters("tomorrow", "date")} id="tomorrow" name="date" className='cursor-pointer' />
                                            <label htmlFor="tomorrow" className="font-normal cursor-pointer text-xs leading-[24px] text-left text-[#2B293D] font-open-sans">
                                                Tomorrow
                                            </label>
                                        </div>
                                        <div className="flex items-center gap-[10px]">
                                            <input type="radio" checked={customDate} onClick={e => { setCustomDate(e.target.checked); setFilters((prev) => ({ ...prev, date: "" })) }} id="custom" name="date" className='cursor-pointer' />
                                            <label htmlFor="custom" className="font-normal cursor-pointer text-xs leading-[24px] text-left text-[#2B293D] font-open-sans">
                                                Custom
                                            </label>
                                        </div>
                                        {customDate &&
                                            <div className='flex items-center gap-[10px] mt-2'>
                                                <DatePicker
                                                    selectsRange={true}
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    onChange={(update) => handleDateRangeFilter(update)}
                                                    isClearable={true}
                                                    placeholderText="Click to select date range"
                                                    className='w-full rounded-md text-[12px] h-9'
                                                    minDate={new Date()}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="flex flex-col gap-3 pb-[20px] border-b border-[#6F6F6F4D]">
                                    <h3 className="font-semibold text-md leading-[28px] text-left text-[#2D2C3C] font-open-sans">Price</h3>
                                    <div>
                                        <div className="flex items-center gap-[10px]">
                                            <input type="radio" onClick={e => handleFilters("free", "type")} checked={filters?.type === "free"} id="free" name="price" className='cursor-pointer' />
                                            <label htmlFor="free" className="font-normal cursor-pointer text-xs leading-[24px] text-left text-[#2B293D] font-open-sans">Free</label>
                                        </div>
                                        <div className="flex items-center gap-[10px]">
                                            <input type="radio" onClick={e => handleFilters("paid", "type")} checked={filters?.type === "paid"} id="paid" name="price" className='cursor-pointer' />
                                            <label htmlFor="paid" className="font-normal cursor-pointer text-xs leading-[24px] text-left text-[#2B293D] font-open-sans">Paid</label>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
    </div>
  </div>
                    <div className="grid grid-cols-12 relative w-full">
                        <div className='col-span-12 lg:col-span-7'>
                            <div className='flex items-center gap-3 justify-between border-b block lg:hidden px-4 py-3'>
                        <h2 class="flex gap-1 items-center font-semibold text-xl leading-[30px] text-[#134896] font-montserrat">
                        <FaFilter className="pr-1" /> Filters</h2>
                        <FaBarsStaggered onClick={toggleModal} className="text-[#005AAB] text-xl"/>
                        </div>
                            <div className="flex-1 py-12 pb-4 flex flex-col px-4">
                                <div className='font-semibold text-[18px] leading-[23.4px] tracking-[0.03em] text-left font-open-sans text-black mb-3'>What's happening near you?</div>
                                <form onSubmit={handleSearch} className='relative'>
                                    <div className='flex flex-wrap gap-2'>
                                        <div className='flex max-md:flex-wrap gap-2'>
                                            <div className='relative max-md:w-[49%] max-[480px]:w-full'>
                                                <input type='text' value={filters?.search} onChange={e => setFilters({ ...filters, search: e.target.value })} className='w-full text-[14px] h-[38px] rounded-[30px] px-3 border-[1px] pl-8 border-[#dfdfdf]' placeholder='Search...' />
                                                <CiSearch className='absolute top-[10px] left-3 text-[18px] text-[#606060]' />
                                            </div>
                                            <div className='relative max-md:w-[49%] max-[480px]:w-full'>
                                                <ReactGoogleAutocomplete
                                                    apiKey={environment?.map_api_key}
                                                    onPlaceSelected={(place) => { handleLocation(place) }}
                                                    onChange={e => setFilters({ ...filters, location: e.target.value })}
                                                    value={filters?.location}
                                                    options={{
                                                        types: ["(regions)"],
                                                        componentRestrictions: { country: "us" },
                                                    }}
                                                    key="eventAddress"
                                                    placeholder="Location..."
                                                    className='w-full text-[14px] h-[38px] rounded-[30px] px-3 border-[1px] pl-8 border-[#dfdfdf]'
                                                />
                                                <CiLocationOn className='absolute top-[10px] left-3 text-[18px] text-[#606060]' />
                                            </div>
                                        </div>
                                        <div className='flex max-md:flex-wrap max-[480px]:justify-center max-[480px]:w-full gap-2'>
                                            <div className='relative max-[480px]:w-full'>
                                                <div className='eventmap_select'>
                                                    <SelectDropdown
                                                        id="statusDropdown"
                                                        displayValue="name"
                                                        theme="search"
                                                        isClearable={false}
                                                        intialValue={filters?.range}
                                                        result={(e) => handleFilters(e.value, "range")}
                                                        options={milesModal.list}
                                                        placeholder="Select Miles"
                                                    />
                                                </div>
                                            </div>
                                            {filters?.search || filters?.location ? <button type='button' onClick={() => clearFilter()} className="flex items-center justify-center h-[38px] text-[14px] text-nowrap font-[500] py-2 px-5 text-white hover:text-[#005AAB] border border-[#005AAB] bg-[#005AAB] hover:bg-transparent rounded-full md:inline-flex">Clear</button> : null}
                                            <button type='submit' className="flex items-center justify-center h-[38px] text-[14px] text-nowrap font-[500] py-1 px-5 text-white hover:text-[#005AAB] border border-[#005AAB] bg-[#005AAB] hover:bg-transparent rounded-full md:inline-flex">Search</button>
                                        </div>
                                    </div>
                                </form>
                                <div className='mt-8'>
                                    <div className="flex flex-col gap-3 lg:h-[calc(100vh_-_303px)] overflow-auto pb-3">
                                        {data && data?.map((item, index) => {
                                            return <div className='shadow_hide relative' key={index}>
                                                <div className='absolute top-[8px] right-[8px]'>
                                                    <SocialShare shareUrl={`${currentDomain}/EventDetails/${item?._id || item?.id}`} />
                                                </div>
                                                <Link to={`/EventDetails/${item?._id || item?.id}`} key={index}>
                                                    <div className="flex gap-[15px] items-center flex-wrap p-4 shadow-md bg-white rounded-lg">
                                                        <img className="max-w-[150px] h-[100px] w-full" src={methodModel.noImg(item?.images?.[0])} alt='event_image' />
                                                        <div className="flex flex-col gap-1">
                                                            <div className='flex justify-between'>
                                                                <h4 className="font-semibold text-[16px] tracking-[0.03em] text-left font-open-sans text-black capitalize">{item?.title}</h4>
                                                            </div>
                                                            <p className="font-normal text-xs tracking-[0.03em] text-left font-open-sans text-black">{moment(item?.eventStartDate).format("DD MMM, YYYY hh:mm A")}</p>
                                                            <p className="flex gap-1 items-center text-[#2B293D] font-normal text-xs tracking-[0.03em] text-left font-open-sans">
                                                                <img className="w-[18px] h-[18px]" src={location} alt="location_icon" /> {item?.location}
                                                            </p>
                                                            <p className="flex gap-1 items-center text-[#2B293D] font-normal text-xs tracking-[0.03em] text-left font-open-sans capitalize">
                                                                {item?.type === "paid" ?
                                                                    <>
                                                                        {item?.ticket_details?.map((itm, i) => {
                                                                            return <span className='flex items-center gap-1' key={i}>
                                                                                <img className="w-[18px] h-[18px]" src={Ticket} alt="ticket_icon" />{itm?.ticket_name} (${itm?.ticket_price})
                                                                            </span>
                                                                        })}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <img className="w-[20px] h-[20px]" src={Ticket} alt="ticket_icon" />Free
                                                                    </>
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        })}
                                        {data?.length === 0 &&
                                            <div className='text-center'>No Records Found</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 lg:col-span-5  max-lg:p-4">
                            <div className='eventmap_div'>
                                <CustomMap locations={locations} mapView={mapView} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default FilterPage;